export default "__VITE_ASSET__DbI_FVbH__"